import { localStorageColorSchemeManager, MantineProvider } from '@mantine/core';
import type { PropsWithChildren } from 'react';

import { AppNotifications } from '@shared/ui/notifications';

import { cssVariablesResolver, theme } from './theme';

const colorSchemeManager = localStorageColorSchemeManager({ key: 'quiz-platform-color-scheme' });

export const Providers = ({ children }: PropsWithChildren) => (
  <MantineProvider
    theme={theme}
    cssVariablesResolver={cssVariablesResolver}
    colorSchemeManager={colorSchemeManager}
    defaultColorScheme="auto"
  >
    <AppNotifications />
    {children}
  </MantineProvider>
);
